import { Base, withScrolledInView } from "@studiometa/js-toolkit";
import { ScrollAnimationChild } from "./ScrollAnimationChild.js";
class ScrollAnimationParent extends withScrolledInView(
  Base,
  {}
) {
  /**
   * Config.
   */
  static config = {
    name: "ScrollAnimationParent",
    components: {
      ScrollAnimationChild
    }
  };
  /**
   * Scrolled in view hook.
   */
  scrolledInView(props) {
    this.$children.ScrollAnimationChild.forEach((child) => {
      child.scrolledInView(props);
    });
  }
}
export {
  ScrollAnimationParent
};
//# sourceMappingURL=ScrollAnimationParent.js.map
